export class BaseApi {
  readonly baseUrl: string

  constructor() {
    this.baseUrl = process.env.NODE_ENV === 'development' ? '/api' : process.env.REACT_APP_API_URL
  }
}
